// Global keyboard behavior controller
// Manages keyboard shortcuts and prevents unintended global actions

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Bind keyboard event handlers
    this.boundHandleSelectAll = this.handleSelectAll.bind(this)
    document.addEventListener('keydown', this.boundHandleSelectAll)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleSelectAll)
  }

  // Prevent Cmd/Ctrl+A from selecting all page content
  // Only allow it within input fields, textareas, and contenteditable elements
  handleSelectAll(event) {
    // Check if Cmd+A (Mac) or Ctrl+A (Windows/Linux)
    const isSelectAll = (event.metaKey || event.ctrlKey) && event.key === 'a'
    if (!isSelectAll) return

    const activeElement = document.activeElement
    const tagName = activeElement?.tagName?.toLowerCase()

    // Allow Cmd/Ctrl+A in input contexts
    const isInputContext =
      tagName === 'input' ||
      tagName === 'textarea' ||
      activeElement?.isContentEditable ||
      activeElement?.hasAttribute('contenteditable')

    // Prevent default if NOT in an input context
    if (!isInputContext) {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
